export default __webpack_public_path__ + "static/media/bp_komfort.cc42e594.svg";